import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

interface Props extends CommandsListProps {
    accountLabel: string;
    optionsKey:
        | "catalogItemBulkIncomeAccountOptions"
        | "catalogItemBulkReceivablesAccountOptions";
}

export const CatalogItemBulkAccountCommandsList: FC<Props> = ({
    options = {},
    accountLabel,
    optionsKey,
}) => {
    const { selectedCatalogItemCount = 0 } = options;
    const accountOptions = options[optionsKey] ?? [];
    const heading = `Set ${accountLabel} for ${pluralizeWithCount("item", selectedCatalogItemCount)}`;
    const hasGroupHeaders = accountOptions.some((option) => option.groupHeader);

    return (
        <>
            {hasGroupHeaders && <Command.Group heading={heading} forceMount />}
            <TaskBulkOptionsCommandsList
                heading={heading}
                options={accountOptions}
            />
        </>
    );
};
